import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import UpdateUser from "../_Login/UpdateUser";


const AccountNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const [account, setAccount] = useState({});
    
    const handleFormSubmit = (e) => {

        let obj = {};

        let valid = true;

        //Validate data
        let newPassword = document.getElementById("password").value;
        let confirmPassword = document.getElementById("confirm").value;
        
        if (newPassword.length + confirmPassword.length != 0){
            if (newPassword != confirmPassword) {
                toast.error('Passwords do not match.');
                valid = false;
            }
            else {
                obj["password"] = newPassword;
            }
        }
        else {
            valid = false;
            toast.error('Password required');
        }

        //first name will not change if no value is provided
        if (document.getElementById("firstname").value != "") {
            obj["firstname"] = document.getElementById("firstname").value;
        }
        else {
            valid = false;
            toast.error('First Name required');
        }

        //last name will not change if no value is provided
        if (document.getElementById("lastname").value != "") {
            obj["lastname"] = document.getElementById("lastname").value;
        }
        else {
            valid = false;
            toast.error('Last Name required');
        }

        //email will not change if no value is provided
        if (document.getElementById("email").value != "") {
            obj["email"] = document.getElementById("email").value;
        }
        else {
            valid = false;
            toast.error('Email required');
        }

        //role must be selected
        if (document.getElementById("role").value != "") {
            if (document.getElementById("role").value == "Admin") {
                obj["isAdmin"] = "1";
            }
            else {
                obj["isAdmin"] = "0";
            }
        }
        else {
            valid = false;
            toast.error('Role required');
        }

        //must change password?
        obj["mustchangepassword"] = document.getElementById("mustchangepassword").checked;

        if(valid) {
            UpdateUser(
                user["id"], 
                "", 
                obj["password"], 
                user["token"], 
                obj["firstname"], 
                obj["lastname"], 
                obj["email"], 
                obj["isAdmin"], 
                obj["mustchangepassword"]
            )
            .then((response) => {
                if(response == "Update successful.") {
                    toast.success('Account created successfully.')
                    navigate("/Account");
                }
                else {
                    toast.error(`Update Failed. ${response}`);
                }
            });
        }
    };

    document.title = "Account - New";
    return ( 
        <div className="AccountNew">
            {user["email"] != undefined && 
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>New Account</h2>

                        <form id="newAccountForm" noValidate="novalidate" autoComplete="off">    

                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input className="form-control" id="email" name="email" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="firstname">First Name</label>
                                <input className="form-control" id="firstname" name="firstname" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="lastname">Last Name</label>
                                <input className="form-control" id="lastname" name="lastname" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <input className="form-control" id="password" name="password" type="password" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirm">Confirm Password</label>
                                <input className="form-control" id="confirm" name="confirm" type="password" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="role">Role</label>
                                <select className="form-control" id="role" name="role">
                                    <option value="">Select Role</option>
                                    <option value="Admin">Admin</option>
                                    <option value="User">User</option>
                                </select>
                            </div>
                            
                            <div className="form-group" style={{marginTop: "32px", marginBottom: "32px"}}>
                                <input className="form-check-input" type="checkbox" id="mustchangepassword" name="mustchangepassword"/>
                                &nbsp;&nbsp;User must change password on next login
                            </div>

                        </form>
                        <Link to="/Account" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>
                    </div>
                </>
            }
        </div>
     );
}
 
export default AccountNew;